import user from './user';

export default new class currencies {
  constructor() {

    this.formatCurrency = (value) => {
      if (!value) return value;
      const locale = user.currentUser.Locale || navigator.language || 'en-US';
      const currency = this.currencies[locale] || 'USD';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value)
      } catch(e) {
        console.log(e);
        return value;
      }
    }

    this.currencies = {
      "en-US": 'USD',
      "de-DE": 'EUR',
      "fr-FR": 'EUR',
      "en-GB": 'GBP',
      "ja-JP": 'JPY',
      "es-MX": 'MXN',
      
      'ha-NG': 'NGN',
      'ig-NG': 'NGN',
      'yo-NG': 'NGN',
    }
  }
}
